import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isBooleanTrue } from '../../core/utils'

import { ALL_SELECT_OPTION_ITEM, PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { ALLOCATE_AUTOMATICALLY_MUTATION } from '../graphql/mutations'
import { MENU_CURATION_TASKS_QUERY } from '../graphql/queries'
import {
  ALLOCATE_AUTOMATICALLY,
  FETCH_MENU_CURATION_TASKS,
} from '../redux/action-types'

import useMenuCurationTasksFetchParams from './use-menu-curation-tasks-fetch-params'
import useMenuCurationTasksListFilters from './use-menu-curation-tasks-list-filters'

const useAllocateAutomaticallyMutation = () => {
  const dispatch = useDispatch()

  const { setFilters } = useMenuCurationTasksListFilters()
  const { filters, sorters, pagination } = useMenuCurationTasksFetchParams()

  const onSuccess = useCallback(() => {
    if (!isBooleanTrue(filters.isCurrentUserAllocated)) {
      return setFilters({
        currentPage: PAGINATION.DEFAULT_PAGE,
        isCurrentUserAllocated: true,
        menuAvailability: ALL_SELECT_OPTION_ITEM.value,
        taskStatus: null,
      })
    }

    return apolloService.query({
      query: MENU_CURATION_TASKS_QUERY,
      variables: { filters, sorters, pagination },
      dispatch,
      action: FETCH_MENU_CURATION_TASKS,
    })
  }, [dispatch, filters, pagination, setFilters, sorters])

  const {
    isAutomaticAllocationLoading: isLoading,
    automaticAllocationError: error,
  } = useSelector(store => store.menuCurationTasks.menuCurationTasks)

  const mutate = useCallback(
    (priorityTaskId, time) =>
      apolloService.mutate({
        mutation: ALLOCATE_AUTOMATICALLY_MUTATION,
        variables: { priorityTaskId, time },
        dispatch,
        action: ALLOCATE_AUTOMATICALLY,
        onSuccess,
      }),
    [dispatch, onSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useAllocateAutomaticallyMutation
